import { useEffect, useState } from 'react';
import { getSuperSetAccessToken, getSuperSetDashboardConfig } from '../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { embedDashboard } from '@superset-ui/embedded-sdk';

const Dashboard = () => {
  const { superSetConfig, superSetAccessToken } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    dispatch(getSuperSetDashboardConfig());
    dispatch(getSuperSetAccessToken());
  }, []);

  useEffect(() => {
    if (loaded) {
      return;
    }

    if (!superSetAccessToken || !superSetConfig) {
      return;
    }

    embedDashboard({
      id: superSetConfig.dashboardid,
      supersetDomain: superSetConfig.url,
      mountPoint: document.getElementById('dashboard'),
      fetchGuestToken: () => superSetAccessToken,
      dashboardUiConfig: {
        hideTitle: true,
        filters: {
          expanded: false
        }
      }
    });

    setLoaded(true);
  }, [superSetConfig, superSetAccessToken, loaded]);

  return (
    <>
      <style>
        {`
        #dashboard iframe {
          width: 100% !important;
          height: 100% !important;
          border: none !important;
        }
      `}
      </style>

      <div id={'dashboard'} style={{ height: 'calc(100vh - 70px)', width: '100%' }}></div>
    </>
  );
};

export default Dashboard;
